export default "__VITE_ASSET__IJ1fF5NM__"